export default (showId) => ({
  acastPlusTiers: ['episode', 'acastPlus', showId],
  episodes: ['show', showId, 'episodes'],
  episode: (episodeId) => ['showId', showId, 'episode', episodeId],
  transcriptRequest: (episodeId) => ['showId', showId, 'episode', episodeId, 'transcriptRequest'],
  transcript: (episodeId) => ['showId', showId, 'episode', episodeId, 'transcript'],
  encoder: (episodeId, audioUrl) => ['showId', showId, 'episodeId', episodeId, 'encoder', audioUrl],
});
